
import HighlightText from 'vue-highlight-text';

export default {
  name: 'PDPCommentBody',
  components: {
    HighlightText,
  },
  props: {
    comment: {
      type: String,
      default: '',
    },
    showModMessage: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    highlight: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    parseCommentBody() {
      return this.comment.split(/\r\n?|\n/).filter((i) => i);
    },
    highlightStyle() {
      return { color: 'initial', 'background-color': 'rgba(255,188,0,0.5)' };
    },
  },
};
